// Server timestamps in the workspace. The API writes UTC without a zone
// ("2026-10-08T14:05:00", the database's naive UTC), which a browser would read as local time.
import { formatDate } from '../../../utils/dateUtils';

const NAIVE_ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;
const DAY_MS = 24 * 60 * 60 * 1000;

/** The timestamp as a Date (a zone-less one is UTC), or null. */
export const parseServerTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const text = String(value).trim();
  const date = new Date(NAIVE_ISO.test(text) ? `${text}Z` : text);
  return Number.isNaN(date.getTime()) ? null : date;
};

const UNITS = [
  ['minute', 60 * 1000],
  ['hour', 60 * 60 * 1000],
  ['day', DAY_MS],
];

/**
 * "5 minutes ago", "2 hours ago", "yesterday"; under a minute `justNow`; the date itself after
 * a week. Empty for a missing or unreadable timestamp.
 */
export const relativeTime = (value, { justNow = 'just now', now = Date.now() } = {}) => {
  const date = parseServerTime(value);
  if (!date) return '';
  const elapsed = now - date.getTime();
  if (elapsed < 60 * 1000) return justNow; // also a clock a little ahead of ours
  if (elapsed >= 7 * DAY_MS) return formatDate(date) || '';

  let unit = UNITS[0];
  UNITS.forEach((candidate) => {
    if (elapsed >= candidate[1]) unit = candidate;
  });
  const amount = Math.floor(elapsed / unit[1]);
  try {
    return new Intl.RelativeTimeFormat('en-CA', { numeric: 'auto' }).format(-amount, unit[0]);
  } catch (error) {
    return formatDate(date) || '';
  }
};
